import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ForwardedCall({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ForwardedCall</title>
      <path
        d="M12.8432 18.1568C14.5559 19.0188 16.5723 19.6404 18.9375 19.9063C19.5115 19.9709 20 19.511 20 18.9334V16.7808C20 16.3219 19.6877 15.9219 19.2425 15.8106L16.5493 15.1373C16.2085 15.0521 15.848 15.152 15.5996 15.4004L12.8432 18.1568ZM12.8432 18.1568C9.72749 16.5888 7.61705 14.225 6.24117 11.7588M6.24117 11.7588C4.93032 9.40926 4.28622 6.96674 4.07481 5.03084C4.01343 4.46884 4.46855 4 5.03389 4H7.1802C7.65688 4 8.06729 4.33646 8.16078 4.80388L8.89504 8.47521C8.96061 8.80307 8.85799 9.14201 8.62157 9.37843L6.24117 11.7588Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M20 4H20.75C20.75 3.58579 20.4142 3.25 20 3.25V4ZM16 3.25C15.5858 3.25 15.25 3.58579 15.25 4C15.25 4.41421 15.5858 4.75 16 4.75V3.25ZM19.25 8C19.25 8.41421 19.5858 8.75 20 8.75C20.4142 8.75 20.75 8.41421 20.75 8H19.25ZM13.4697 9.46967C13.1768 9.76256 13.1768 10.2374 13.4697 10.5303C13.7626 10.8232 14.2374 10.8232 14.5303 10.5303L13.4697 9.46967ZM20 3.25H16V4.75H20V3.25ZM19.25 4V8H20.75V4H19.25ZM14.5303 10.5303L20.5303 4.53033L19.4697 3.46967L13.4697 9.46967L14.5303 10.5303Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
